import React from 'react';
import {observer} from 'mobx-react';

import {PracticeStoreContext} from 'core/stores/RootStore.js';
import RelatedInfo from 'core/components/RelatedInfo.js';

export default
@observer
class PracticeRelatedInfo extends React.Component {
    static contextType = PracticeStoreContext;

    render() {
        const {practice, practiceRelatedContent} = this.context;
        if (!practiceRelatedContent) {
            return null;
        }
        return (
            <RelatedInfo
                communities={practiceRelatedContent.relatedTopics}
                factsheets={practiceRelatedContent.relatedFactsheets}
                name={practice.name}
            />
        );
    }
}
